import { render, staticRenderFns } from "./TopBarUser.vue?vue&type=template&id=34a8f94a&scoped=true&"
import script from "./TopBarUser.vue?vue&type=script&lang=js&"
export * from "./TopBarUser.vue?vue&type=script&lang=js&"
import style0 from "./TopBarUser.vue?vue&type=style&index=0&id=34a8f94a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a8f94a",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/TopBarUser.vue
// module id = null
// module chunks = 